module.exports = __webpack_public_path__ + "img/case-logo-8.b246b411.png";